import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/loader/loader';
import { Box, Paper, Tooltip } from "@mui/material";
import { Button, Form, InputGroup } from 'react-bootstrap';
import moment from 'moment';
import { IoCloseSharp, IoCloudDownloadOutline } from "react-icons/io5";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { IoSearch } from "react-icons/io5";
import { getSentLogListing } from '../../api/context/report';
import viewIcon from "../../assets/images/view.svg";
import Select from 'react-select'
import { useFormik } from 'formik'
import { DatePicker, Space } from 'antd';
import filtericon from '../../assets/images/Filter.png';
import Offcanvas from 'react-bootstrap/Offcanvas';
import refreshIcon from '../../assets/images/recycle.png';
import { reportListFilter, reportListLimit, reportListPage, reportListSearch, reportListSubject, reportListTemplate } from '../../atoms/reportListFilter';
import { useRecoilState } from 'recoil';

const { RangePicker } = DatePicker;

const queueDatatableCustomStyles = {
    headCells: {
        style: {
            display: "flex",
            // justifyContent: "center",
            fontWeight: '600',
            fontSize: '14px',

        },
    },
    cells: {
        style: {
            display: "flex",
            // justifyContent: "center",
            fontSize: '12px',
            fontWeight: '500',
            padding: '12px',
        },
    },

};
const customStyless = {
    control: (provided) => ({
        ...provided,
        border: " 1px solid #EBEBEB",
        padding: '6px',
    }),
};



const Report = () => {

    const navigate = useNavigate()

    const [filter, setFilter] = useRecoilState(reportListFilter);
    const [page, setPage] = useRecoilState(reportListPage);
    const [limit, setLimit] = useRecoilState(reportListLimit);
    const [search, setSearch] = useRecoilState(reportListSearch);
    const [templateSearch, setTemplateSearch] = useRecoilState(reportListTemplate);
    const [subjectSearch, setSubjectSearch] = useRecoilState(reportListSubject);

    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    // const [limit, setLimit] = useState(25);
    // const [page, setPage] = useState(0);
    // const [search, setSearch] = useState('')
    // const [templateSearch, setTemplateSearch] = useState('');
    // const [subjectSearch, setSubjectSearch] = useState("");
    const [update, setUpdate] = useState(false);
    const [reportLog, setReportLog] = useState([]);
    const [show, setShow] = useState(false);
    const [loader, setLoader] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    // REQUEST_INITIALIZED   = 1
    // PROCESSING_REQUEST    = 2
    // REQUEST_COMPLETED     = 3
    // REQUEST_FAILED        = 4
    // SQS_DATA_UPLOAD       = 5
    // SQS_DATA_PROCESSING   = 6
    // EMAIL_SEND_COMPLTED   = 7
    // EMAIL_SEND_FAILED     = 8

    const statusOptions = [
        { value: '1', label: 'Request Initialized' },
        { value: '2', label: 'Processing Request' },
        { value: '3', label: 'Request Completed' },
        { value: '4', label: 'Request Failed' },
        { value: '5', label: 'SQS Data Upload' },
        { value: '6', label: 'SQS Data Processing' },
        { value: '7', label: 'Email Send Completed' },
        { value: '8', label: 'Email Send Failed' },
    ]

    const searchFormik = useFormik({
        initialValues: {
            mail_type: filter.mail_type || '',
            selected_status: filter.selected_status || '',
            created_date: filter.created_date || '',
            date_sent: filter.date_sent || ''
        },
        validate: async (values) => {
            // Add validation logic if needed
        },
        onSubmit: (values, { resetForm }) => {
            setLoading(true);
            const skip = page !== 0 ? (page - 1) * limit : 0;
            setFilter(values);
            getSentLogListing({
                skip,
                limit,
                search,
                templateSearch,
                subjectSearch,
                filters: values // Pass the formik values as filters
            })((response) => {
                if (response?.status_code === 200) {
                    setReportLog(response?.data?.results);
                    setTotalRows(response?.data?.count);
                    setShow(false);
                } else {
                    setReportLog([]);
                }
                setLoading(false);
            });
        },
    });

    const columns = [
        {
            name: "S. No.",
            selector: (row, index) => page == 0 ? index + 1 : (page - 1) * limit + index + 1,
            width: '90px',
            center: true
        },
        {
            id: 'template',
            name: 'Template',
            selector: (row) => row?.template,
            cell: (row) => <Tooltip title={row?.template} disableInteractive placement='top'><div className='ellipse_email'>{row?.template}</div></Tooltip>,
            grow: 1.9,
            minWidth: '250px',
            reorder: true,
            left: true,
        },
        {
            id: 'email_subject',
            name: 'Subject',
            selector: (row) => row?.email_subject,
            cell: (row) => <Tooltip title={row?.email_subject} disableInteractive placement='top'><div className='ellipse_email'>{row?.email_subject}</div></Tooltip>,
            grow: 1.9,
            minWidth: '250px',
            reorder: true,
            left: true,
        },
        {
            id: 'created_date',
            name: 'Created Date',
            selector: (row) => moment(row?.created_date).format('DD/MM/YYYY, HH:mm:ss.SSS'),
            cell: (row) => (
                <Tooltip 
                    title={moment(row?.created_date).format('DD/MM/YYYY, HH:mm:ss.SSS')} 
                    disableInteractive 
                    placement='top'
                >
                    <div className='ellipse_email'>{moment(row?.created_date).format('DD/MM/YYYY, HH:mm:ss.SSS')}</div>
                </Tooltip>
            ),
            grow: 0.4,
            minWidth: '200px',
            reorder: true,
        },
        {
            id: 'date_sent',
            name: 'Date Sent',
            selector: (row) => moment(row?.date_sent).format('DD/MM/YYYY, HH:mm:ss.SSS'),
            cell: (row) => (
                <Tooltip 
                    title={moment(row?.date_sent).format('DD/MM/YYYY, HH:mm:ss.SSS')} 
                    disableInteractive 
                    placement='top'
                >
                    <div className='ellipse_email'>{moment(row?.date_sent).format('DD/MM/YYYY, HH:mm:ss.SSS')}</div>
                </Tooltip>
            ),
            grow: 0.4,
            minWidth: '200px',
            reorder: true,
        },
        {
            id: 'status',
            name: 'Status',
            selector: (row) => row?.status,
            cell: (row) => <Tooltip title={row?.status} disableInteractive placement='top'><div className='ellipse_email'>{row?.status}</div></Tooltip>,
            grow: 1,
            minWidth: '200px',
            reorder: true,
            left: true,
        },
        // {
        //     id: 'updatedAt',
        //     name: 'Updated Date',
        //     selector: (row) => moment(row?.modified_date).format('DD/MM/YYYY, hh:mm a'),
        //     cell: (row) => (
        //         <Tooltip title={moment(row?.modified_date).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement='top'>
        //             <div className='ellipse_email'>{moment(row?.modified_date).format('DD/MM/YYYY, hh:mm a')}</div>
        //         </Tooltip>
        //     ),
        // },

        {
            name: "ACTION",
            cell: (row) =>
                <div>

                    <div className='d-flex flex-row gap-3' role='button'>
                        <Tooltip title="View" disableInteractive placement="top">
                            <img
                                src={viewIcon}
                                alt=""
                                onClick={() => navigate('/report-details', { state: { reportId: row.id } })}
                            />
                        </Tooltip>
                    </div>

                </div>,
            grow: 0.1,
            minWidth: '200px',
            reorder: true,
            center: true
        },
    ];



    const fetchSentLogListing = async () => {
        setLoading(true);
        const skip = page != 0 ? (page - 1) * limit : 0;
        getSentLogListing({ skip, limit, search, templateSearch, subjectSearch, filters: filter })((response) => {
            console.log(response, 'response');
            if (response?.status_code === 200) {
                setReportLog(response?.data?.results);
                setTotalRows(response?.data?.count);
            } else {
                setReportLog([]);
            }
            setLoading(false);
        });
    };


    // const handleSearchData = (e) => {
    //     setSearch(e.target.value);
    //     if (e.target.value == '') {
    //         setUpdate(!update);
    //     }
    // }

    // const handleClearSearch = () => {
    //     setSearch('');
    //     setUpdate(!update);
    // }

    // const handleEmailSearchData = (e) => {
    //     setTemplateSearch(e.target.value);
    //     if (e.target.value === '') {
    //         setUpdate(!update);
    //     }
    // };

    // const handleClearEmailSearch = () => {
    //     setTemplateSearch('');
    //     setUpdate(!update);
    // };

    // const handleSubjectSearchData = (e) => {
    //     setSubjectSearch(e.target.value);
    //     if (e.target.value === "") {
    //         setUpdate(!update); // Trigger fetch if input is cleared
    //     }
    // };

    // const handleClearSubjectSearch = () => {
    //     setSubjectSearch("");
    //     setUpdate(!update); // Trigger fetch
    // };

    // useEffect(() => {
    //     const timeout = setTimeout(() => {
    //         if (search !== '' || templateSearch !== '' || subjectSearch !== '') {
    //             setUpdate(!update);
    //         }
    //     }, 800);
    //     return () => {
    //         clearTimeout(timeout);
    //     };
    // }, [search, templateSearch, subjectSearch]); // Add emailSearch here

    useEffect(() => {
        if (loader) {
            const timeout = setTimeout(() => {
                // Set loader to false after 500ms (adjust as needed)
                setLoader(false);
            }, 500); // Adjust timeout duration for blinking effect

            return () => clearTimeout(timeout);
        }
    }, [loader]); // Effect runs when loader state changes

    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
        setPage(0);
        setUpdate(!update);
    };

    const handlePageChange = (page) => {
        setPage(page);
        setUpdate(!update);
    };

    const onStatusChange = (selectedOption) => {
        searchFormik.setValues({
            ...searchFormik.values,
            mail_type: selectedOption?.value,
            selected_status: selectedOption
        })
    }

    const onCreatedChangeDate = (value) => {
        if (value != null) {
            const startDate = value[0].format("YYYY/MM/DD") + " 00:00:00"; // Start of day
            const endDate = value[1].format("YYYY/MM/DD") + " 23:59:59";   // End of day
            const createdDateRange = `${startDate} - ${endDate}`;

            searchFormik.setValues({
                ...searchFormik.values,
                created_date: createdDateRange, // Combined date range
            });
        } else {
            searchFormik.setValues({
                ...searchFormik.values,
                created_date: "", // Reset created_date
            });
        }
    };

    const onSentChangeDate = (value) => {
        if (value != null) {
            const startDate = value[0].format("YYYY/MM/DD") + " 00:00:00"; // Start of day
            const endDate = value[1].format("YYYY/MM/DD") + " 23:59:59";   // End of day

            searchFormik.setValues({
                ...searchFormik.values,
                date_sent: `${startDate} - ${endDate}`,
            });
        } else {
            searchFormik.setValues({
                ...searchFormik.values,
                date_sent: "",
            });
        }
    };


    useEffect(() => {
        setLoading(true);
        fetchSentLogListing();

    }, [update]);

    const handleReset = () => {
        searchFormik.resetForm();
        setSearch('');
        setTemplateSearch('');
        setSubjectSearch('');
        setShow(false);
        setPage(0);
        setLimit(25);  // This should reset limit to 25
        setUpdate(!update); // Trigger re-fetch with updated limit and page
        setLoader(true)
    };

    const refreshData = () => {
        setUpdate(!update);
    }

    const isFilterApplied = !!(
        search ||
        templateSearch ||
        subjectSearch ||
        searchFormik.values.selected_status ||
        searchFormik.values.created_date ||
        searchFormik.values.date_sent
    );
    console.log("Limit:", limit); // Should log 25 after reset
    console.log("Page:", page); // Should log 0 after reset


    return (
        <>
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 className="mb-sm-0">Reports</h4>

                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="request_wrapper_filter_reports">
                        <div className='refresh_btn'>
                            <Button className='btn btn-refresh' onClick={refreshData}>Refresh <span><img src={refreshIcon} className={`${loading ? 'sync_data_rotate img-fluid' : 'img-fluid'}`} alt='refresh icon' /></span></Button>
                        </div>
                        <div className="filters" onClick={handleShow}>
                            <img
                                src={filtericon}
                                className="img-fluid filter_icon"
                                alt="Filter Icon"
                            />
                            {isFilterApplied && (
                                <span
                                    className='rounded-circle-mic'
                                />
                            )}
                            <h5>Filters</h5>
                        </div>
                    </div>


                    <Offcanvas show={show} onHide={handleClose} placement='end'>
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Filters</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <div className="request_wrapper_filter">
                                <Form onSubmit={searchFormik.handleSubmit}>
                                    <div className='dataTable-left'>
                                        <div className='mb-3'>
                                            <Form.Label className='mb-2'>Search by email</Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    placeholder="Search"
                                                    aria-label="Search"
                                                    aria-describedby="basic-addon2"
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)} // Only update the state
                                                />
                                                {/* {search && (
                                                    <InputGroup.Text id="basic-addon3" onClick={handleClearSearch} style={{ cursor: "pointer" }}>
                                                        <IoCloseSharp />
                                                    </InputGroup.Text>
                                                )} */}
                                            </InputGroup>
                                        </div>

                                        <div className='mb-3'>
                                            <Form.Label className='mb-2'>Search by template</Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    placeholder="Search"
                                                    aria-label="Search"
                                                    aria-describedby="basic-addon2"
                                                    value={templateSearch}
                                                    onChange={(e) => setTemplateSearch(e.target.value)} // Only update the state
                                                />
                                                {/* {templateSearch && (
                                                    <InputGroup.Text id="basic-addon3" onClick={handleClearEmailSearch} style={{ cursor: "pointer" }}>
                                                        <IoCloseSharp />
                                                    </InputGroup.Text>
                                                )} */}
                                            </InputGroup>
                                        </div>

                                        <div className='mb-3'>
                                            <Form.Label className='mb-2'>Search by subject</Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    placeholder="Search"
                                                    aria-label="Search"
                                                    aria-describedby="basic-addon4"
                                                    value={subjectSearch}
                                                    onChange={(e) => setSubjectSearch(e.target.value)} // Only update the state
                                                />
                                                {/* {subjectSearch && (
                                                    <InputGroup.Text
                                                        id="basic-addon5"
                                                        onClick={handleClearSubjectSearch}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <IoCloseSharp />
                                                    </InputGroup.Text>
                                                )} */}
                                            </InputGroup>
                                        </div>
                                    </div>
                                    <div className='seperation_filter_reports'>
                                        {/* <Form.Group className="">
                                    <Form.Label>From</Form.Label>
                                    <div className="select-container">
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={["DatePicker"]}>
                                                <DatePicker
                                                    value={dayjs(searchFormik.values.created_date)}
                                                    onChange={(newValue) => {
                                                        const createDate = dayjs(newValue).format('YYYY/MM/DD');
                                                        searchFormik.setValues({
                                                            ...searchFormik.values,
                                                            created_date: createDate,
                                                        });
                                                    }}
                                                    format="DD-MM-YYYY"
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </div>
                                </Form.Group> */}
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label className='mb-2'>Created Date</Form.Label>
                                            <div className='input-border'>
                                                <Space direction="vertical" size={12}>
                                                    <RangePicker
                                                        format="YYYY-MM-DD"
                                                        value={
                                                            searchFormik.values.created_date
                                                                ? [
                                                                    dayjs(searchFormik.values.created_date.split(" - ")[0], "YYYY/MM/DD HH:mm:ss"),
                                                                    dayjs(searchFormik.values.created_date.split(" - ")[1], "YYYY/MM/DD HH:mm:ss"),
                                                                ]
                                                                : null
                                                        }
                                                        onChange={(value) => onCreatedChangeDate(value)}
                                                    />
                                                </Space>
                                            </div>
                                        </Form.Group>
                                        {/* <Form.Group className="">
                                    <Form.Label>To</Form.Label>
                                    <div className="select-container">
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={["DatePicker"]}>
                                                <DatePicker
                                                    value={dayjs(searchFormik.values.date_sent)}
                                                    onChange={(newValue) => {
                                                        const dateSent = dayjs(newValue).format('YYYY/MM/DD');
                                                        searchFormik.setValues({
                                                            ...searchFormik.values,
                                                            date_sent: dateSent,
                                                        });
                                                    }}
                                                    format="DD-MM-YYYY"
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </div>
                                </Form.Group> */}
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label className='mb-2'>Date Sent</Form.Label>
                                            <div className='input-border'>
                                                <Space direction="vertical" size={12}>
                                                    <RangePicker
                                                        format="YYYY-MM-DD"
                                                        value={
                                                            searchFormik.values.date_sent
                                                                ? [
                                                                    dayjs(searchFormik.values.date_sent.split(" - ")[0], "YYYY/MM/DD HH:mm:ss"),
                                                                    dayjs(searchFormik.values.date_sent.split(" - ")[1], "YYYY/MM/DD HH:mm:ss"),
                                                                ]
                                                                : null
                                                        }
                                                        onChange={(value) => onSentChangeDate(value)}
                                                    />
                                                </Space>


                                            </div>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='mb-2'>Status </Form.Label>
                                            <div className='input-border dotted-select'>
                                                <Select
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 4,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary: '#779be1',
                                                        },
                                                    })}
                                                    placeholder='Select Status'
                                                    options={statusOptions}
                                                    value={searchFormik.values.selected_status}
                                                    onChange={onStatusChange}
                                                    styles={{
                                                        menu: (baseStyles) => ({
                                                            ...baseStyles,
                                                            zIndex: 9999,
                                                        }),
                                                    }}
                                                    isClearable={true}
                                                />
                                            </div>

                                        </Form.Group>
                                        <div className='btn-groups'>
                                            <Button className='search_filter' type='submit'>Search</Button>
                                            <Button className='reset_btn_wrapper' onClick={handleReset}>Reset</Button>
                                        </div>
                                    </div>
                                </Form>
                                {/* <div className="request_btn_wrapper" >


                            <div className="request_btn mt-3">
                                <IoCloudDownloadOutline className='icon' />
                                Export Excell
                            </div>

                        </div> */}
                            </div>
                        </Offcanvas.Body>
                    </Offcanvas>

                    <div className="d_grid_wrapper"></div>
                </div>
                <div className='col-12'>
                    <Box className="products-and-options" sx={{ mt: 1 }}>
                        <Paper square>
                            {!loader &&
                                <div>
                                    <DataTable
                                        columns={columns}
                                        data={reportLog}
                                        progressPending={loading}
                                        progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                                        pagination
                                        paginationServer
                                        paginationTotalRows={totalRows}
                                        paginationPerPage={limit}
                                        paginationRowsPerPageOptions={[25, 50, 75, 100]}
                                        onChangeRowsPerPage={handlePerRowsChange}
                                        onChangePage={handlePageChange}
                                        currentPage={page}
                                        customStyles={queueDatatableCustomStyles}
                                    />
                                </div>
                            }
                        </Paper>
                    </Box>


                </div>

            </div>
        </>
    )
}

export default Report